export const fileSourceList = [
  {
    name: "其他",
    value: "0"
  },
  {
    name: "设备自建监控点",
    value: "1"
  },
  {
    name: "行车记录仪",
    value: "2"
  },
  {
    name: "手机",
    value: "3"
  }
];
